import { convertByEnumName, LicenseModuleEnum } from "./LicenseModuleEnum";

export class InstallationLicenseData {
    /**Enabled license modules  */
    enabledModules: LicenseModuleEnum = LicenseModuleEnum.None;

    /**Installation attributes */
    devAttributes: string = null;

    /**Installation checksum */
    licenseChecksum: string = null;

    /**License expiration  */
    changeLicenseExpiration: Date = null;

    /**Registration date time */
    registration: Date = null;

    daysToChangeModules: number = 0;

    public parse(obj: any) {
        if (obj.EnabledModules)
            this.enabledModules = convertByEnumName(obj.EnabledModules);
        if (obj.DevAttributes)
            this.devAttributes = obj.DevAttributes;
        if (obj.LicenseChecksum)
            this.licenseChecksum = obj.LicenseChecksum;
        if (obj.ChangeLicenseExpiration)
            this.changeLicenseExpiration = obj.ChangeLicenseExpiration;
        if (obj.Registration)
            this.registration = obj.Registration;
        if (obj.DaysToChangeModules)
            this.daysToChangeModules = obj.DaysToChangeModules;
    }
}